import { ReactElement } from "react";
import { Col } from "reactstrap";
import ButtonContainer from "@components/ButtonContainer";
import LinkVariantIcon from "mdi-react/LinkVariantIcon";
import FormatTitleIcon from "mdi-react/FormatTitleIcon";
import ImageFilterDramaIcon from "mdi-react/ImageFilterDramaIcon";
import { useTranslation } from "react-i18next";
import BoxStatus from "@components/BoxStatus";
import OpenInNewIcon from "mdi-react/OpenInNewIcon";
import ICarouselItem from "@interfaces/Clients/WhaleShark/vaultCarousel/carouselItem";
import BoxImage from "@components/BoxImage";

interface IDetailForm {
  data: ICarouselItem;
}

const DetailForm = ({ data }: IDetailForm): ReactElement => {
  const { t } = useTranslation(["whaleshark", "core"]);

  return (
    <form className="form">
      {data && (
        <Col md={5}>
          <BoxImage urlImage={data.imageUrl} />
        </Col>
      )}

      <Col md={7}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t("core:common.title")}
          </span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <FormatTitleIcon />
            </div>
            <input type="text" value={data?.title} disabled />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">
            {t("core:common.url_image")}
          </span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <ImageFilterDramaIcon />
            </div>
            <input type="text" value={data?.imageUrl} disabled />
            <a href={data?.imageUrl} target="_blank" rel="noopener noreferrer">
              <div className="form__form-group-icon">
                <OpenInNewIcon />
              </div>
            </a>
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">
            {t("core:common.opensea_url")}
          </span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <LinkVariantIcon />
            </div>
            <input type="text" value={data?.openSeaUrl} disabled />
            <a
              href={data?.openSeaUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="form__form-group-icon">
                <OpenInNewIcon />
              </div>
            </a>
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">
            {t("core:common.state")}
          </span>
          <div className="form__form-group-field">
            <BoxStatus state={data?.state ?? true} />
          </div>
        </div>
      </Col>
      <ButtonContainer />
    </form>
  );
};

export default DetailForm;
